/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';
import { Text } from './Text';
import { Title } from './Title';

const DepositLeftMoneyError = () => {
  const { t } = useTranslation();

  return (
    <>
      <Icon type={'error'} />
      <Title>{t('NOTIFICATION_DEPOSIT_LEFT_MONEY_ERROR__title')}</Title>
      <Text>{t('NOTIFICATION_DEPOSIT_LEFT_MONEY_ERROR__desc')}</Text>
    </>
  );
};

export { DepositLeftMoneyError };
